'use strict';

wbApp.factory('userRolesSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {
        var UserRole = $resource('/Api/UserRoles/Get', {}, {
            'query':  { method: 'GET', isArray: true },
            'save': { method: 'POST', url: '/Api/UserRoles/Save' },
            'delete': { method: 'POST', url: '/Api/UserRoles/Delete' }
        });

        var userRoles;
        var userRolesDict = {};

        function getAllAsync(refresh) {
            if (!userRoles || !!refresh) {
                userRolesDict = {};
                userRoles = repositorySvc.get(UserRole, '', function (result) {
                    for (var r = 0; r < result.length; r++) {
                        var role = result[r];
                        role.sf = ConvertArrayToProperties(role.securityFeatures);
                        userRolesDict[role.id] = role;
                    }
                });
            }
            return userRoles;
        }

        function ConvertArrayToProperties(array) {
            var sf = {};
            if (array) {
                for (var f = 0; f < array.length; f++) {
                    sf[array[f]] = true;
                }
            }

            return sf;
        }

        function ConvertPropertiesToArray(sf) {
            var array = [];
            if (sf) {
                for (var propertyName in sf) {
                    if (sf[propertyName]) {
                        array.push(propertyName);
                    }
                }
            }

            return array;
        }

        function get(id) {
            return userRolesDict[id];
        }

        function save(data, successCallback, errorCallback) {

            data.securityFeatures = ConvertPropertiesToArray(data.sf);
           // data.sf = undefined;
            repositorySvc.save(
                UserRole,        // $resource
                userRoles,       // collection
                data,            // entity
                function (data) {
                    data.sf = ConvertArrayToProperties(data.securityFeatures);
                    if (successCallback) {
                        successCallback(data);
                    }
                },
                errorCallback);
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                UserRole,        // $resource
                userRoles,       // collection
                data,            // entity
                null,            // successCallback
                errorCallback);
        }

        function createNew() {
            return extendWithRfidSchedule({
                id: -1,
                name: "",
                description: "",
                buildIn: false,
                sf: {},
                rfidAccessGroup: {
                    rfidAccessGroupID: 255
                }
            });
        }

        function extendWithRfidSchedule(model) {

            if (model.rfidAccessGroup.rfidAccessGroupID == 255 ||
                model.rfidAccessGroup.rfidAccessGroupID == 254 ||
                model.rfidAccessGroup.rfidAccessGroupID == 253) {

                model.rfidAccessGroup.schedule = {
                    sunday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    monday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    tuesday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    wednesday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    thursday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    friday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                    saturday: { period0: { startTime: 0, endTime: 0 }, period1: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period2: { startTime: 0, endTime: 0 }, period3: { startTime: 0, endTime: 0 }, period4: { startTime: 0, endTime: 0 } },
                };
            }

            return model;
        }

        return {
            getAllAsync: getAllAsync,
            get: get,
            save: save,
            remove: remove,
            createNew: createNew,
            extendWithRfidSchedule: extendWithRfidSchedule
        }
    }
]);
